module.exports = __webpack_public_path__ + "static/media/dispatch_systemmoduleC-icon3.5dfce618.png";